import _ = require('underscore');

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceInfo } from '../../../datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { userCanCreateExtractOnEmbeddedDs } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IExtractConvertAction } from '../../../spacesPlatform/models/actionNames';
import { selectSpaceInfo } from '../../../spacesPlatform/selectors/SpaceInfoSelectors';
import { isWorkbookSpace, SpaceInfo } from '../../../spacesPlatform/state/SpaceInfo';
import { changeExtractDsToLive } from '../../actions/ChangeExtractDsToLiveAction';

export const ChangeExtractEmbeddedDsToLiveAction: IEntityAction<IDataSourceInfo, IExtractConvertAction> = {
  name: EntityActionNames.ChangeExtractDsToLiveEmb,
  translateName: Messages.changeExtractDsToLiveAction,
  isVisible: (targetItems: IDataSourceInfo[], state: AppState) => {
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    return isWorkbookSpace(spaceInfo) && _.any(targetItems, (targetItem) => targetItem.contentType === 'datasource');
  },
  isClickable: (availableActions: IExtractConvertAction, targetItems: IDataSourceInfo[], state: AppState) => {
    return userCanCreateExtractOnEmbeddedDs(state) &&
      _.any(targetItems, (targetItem) => targetItem.hasExtracts && !targetItem.isExtractOnly && !targetItem.isFileBased &&
        targetItem.connectionType !== 'sqlproxy' && targetItem.connectionType !== 'publishedConnection');
  },
  isChecked: (availableActions: {}, targetItems: IDataSourceInfo[], state: AppState) => {
    return _.all(targetItems, (targetItem) => !targetItem.hasExtracts);
  },
  createReduxAction: (dataSources: IDataSourceInfo[]) => changeExtractDsToLive(dataSources)
};
